import { AppleGlyph, PlayGlyph } from "@/components/Glyphs";
import { PLAY_STORE_URL } from "@/data/site";

const LiveBadge = ({ icon, kicker, store, href, testid }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className="group relative flex items-center gap-3 overflow-hidden rounded-xl border border-gold/40 bg-card/80 px-4 py-2.5 backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:border-gold hover:shadow-[0_8px_30px_-10px_rgba(212,175,55,0.5)]"
  >
    <span className="text-foreground">{icon}</span>
    <span className="flex flex-col leading-none text-left">
      <span className="text-[10px] font-medium uppercase tracking-[0.18em] text-gold">{kicker}</span>
      <span className="mt-1 font-display text-base font-semibold text-foreground">{store}</span>
    </span>
    <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-gold/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
  </a>
);

const SoonBadge = ({ icon, kicker, store, testid }) => (
  <div
    data-testid={testid}
    aria-disabled="true"
    className="group relative flex cursor-default items-center gap-3 overflow-hidden rounded-xl border border-border bg-card/70 px-4 py-2.5 backdrop-blur transition-colors hover:border-gold/40"
  >
    <span className="text-foreground/90">{icon}</span>
    <span className="flex flex-col leading-none text-left">
      <span className="text-[10px] font-medium uppercase tracking-[0.18em] text-gold">{kicker}</span>
      <span className="mt-1 font-display text-base font-semibold text-foreground">{store}</span>
    </span>
    <span className="absolute -right-10 -top-6 rotate-45 bg-gold/20 px-10 py-1 text-[9px] font-bold uppercase tracking-widest text-gold">
      Soon
    </span>
  </div>
);

export default function StoreBadges({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="store-badges">
      <SoonBadge icon={<AppleGlyph className="h-7 w-7" />} kicker="Coming soon" store="App Store" testid="badge-app-store" />
      <LiveBadge icon={<PlayGlyph className="h-6 w-6" />} kicker="Get it on" store="Google Play" href={PLAY_STORE_URL} testid="badge-google-play" />
    </div>
  );
}
